import axios from 'axios';
import {
    handle
} from 'redux-pack';
import { prosperityContact } from './index';

// Actions
export const PROSPERITY_IS_LOADING = 'PROSPERITY_IS_LOADING';
export const PROSPERITY_HAS_ERROR = 'PROSPERITY_HAS_ERROR';
export const PROSPERITY_UPDATE = 'PROSPERITY_UPDATE';
export const PROSPERITY_FORM_SUBMIT = 'PROSPERITY_FORM_SUBMIT';

// Default State
const initialState = {
    isLoading: false,
    hasError: false,
    skipFinancial: false
};

export const updateProsperityPath = dispatch => (skip) => {
    dispatch({
        type: PROSPERITY_UPDATE,
        response: {
            skipFinancial: skip
        }
    });
};

export const prosperityContactSubmit = (token, data) => ({
    type: PROSPERITY_FORM_SUBMIT,
    promise: axios({
        url: prosperityContact,
        method: 'POST',
        data,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
});

export default (state = initialState, action = {}) => {
    const {
        type,
        response,
        isLoading,
        hasError
    } = action;

    switch (type) {
        case PROSPERITY_FORM_SUBMIT:
            return handle(state, action, {
                start: prevState => ({
                    ...prevState,
                    isLoading: true
                }),
                success: (prevState, { payload: token }) => ({
                    ...prevState,
                    token,
                    hasError: false
                }),
                failure: prevState => ({
                    ...prevState,
                    hasError: true
                }),
                finish: prevState => ({
                    ...prevState,
                    isLoading: false
                })
            });
        case PROSPERITY_IS_LOADING:
            return {
                ...state,
                isLoading
            };
        case PROSPERITY_HAS_ERROR:
            return {
                ...state,
                hasError
            };
        case PROSPERITY_UPDATE:
            return {
                ...state,
                ...response
            };
        default:
            return state;
    }
}
